import React from 'react';
import { cm } from 'src/utils/classNames';
import { signDependentValue } from 'src/utils/signDependentValue';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithChildren, WithClassName {
	value?: number;
}

const SignDependentColorValue = ({ value, className, children }: Props) => {
	return (
		<span
			className={cm(
				signDependentValue(value, {
					positive: 'text-text-positive-green-button',
					negative: 'text-text-negative-red-button',
					zero: 'text-text-default',
					undefined: '',
				}),
				className
			)}
		>
			{children}
		</span>
	);
};

export default SignDependentColorValue;
